import { FC, ReactNode } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { store, persistor } from 'application/store';

const StoreProvider: FC<{ children?: ReactNode }> = ({ children }) => (
  <ReduxProvider store={store}>
    <PersistGate
      loading={null}
      persistor={persistor}>
      {children}
    </PersistGate>
  </ReduxProvider>
);

export default StoreProvider;
